import { Link } from 'react-router-dom'
import { AuthLayout } from '@/modules/auth/ui/components'
import { LoadingSpinner } from '@/shared/ui/components'
import { Button } from '@/shared/ui/primitives'
import type { LinkClub } from '@/modules/auth/use-cases'
import { useMagicLinkPage } from './hooks/use-magic-link-page'

export type MagicLinkPageProps = {
  onLinkClub: LinkClub
}

export function MagicLinkPage({ onLinkClub }: MagicLinkPageProps) {
  const vm = useMagicLinkPage({ onLinkClub })

  if (vm.status === 'error') {
    return (
      <AuthLayout
        title="Setup error"
        subtitle="We couldn't finish setting up your club."
      >
        <div data-testid="magic-link-error" className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">{vm.errorMessage}</p>
          <Button asChild variant="default" className="w-full">
            <Link to="/signup">Restart onboarding</Link>
          </Button>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout
      title="Completing setup"
      subtitle="We're finishing your club setup. This will only take a moment."
    >
      <div
        data-testid="magic-link-loading"
        className="flex flex-col items-center justify-center gap-3 py-6"
      >
        <LoadingSpinner size="lg" />
      </div>
    </AuthLayout>
  )
}
